import { render, staticRenderFns } from "./BlockedClientsForm.vue?vue&type=template&id=e3dc109e&"
import script from "./BlockedClientsForm.vue?vue&type=script&lang=ts&"
export * from "./BlockedClientsForm.vue?vue&type=script&lang=ts&"
import style0 from "./BlockedClientsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports